
export enum BlockType {
	WYSIWYGBlock = 'WysiwygBlock',	
}

export enum AlignmentType {
	Right = 'Right',
	Left = 'Left',
	Center = 'Center',
}

export interface BaseBlockModel {
	blockType: string | BlockType;
}

export interface WysiwygBlock extends BaseBlockModel {	
	wysiwygContent: string;
	calloutColor: string;
    hasTopBorder: boolean;
	hasRightBorder: boolean;
	hasBottomBorder: boolean;
	hasLeftBorder: boolean;
	isPod: boolean;
}

export interface ImageBlock extends BaseBlockModel {	
	captionWysiwyg: string;
	image: string;
    targetFrameRaw: string;
	linkUrl: string;	
	imageAltText: string;
}
